module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('aside', {
    staticClass: "leftbar material-leftbar"
  }, [_c('div', {
    staticClass: "left-aside-container"
  }, [_c('div', {
    staticClass: "user-profile-container"
  }, [_c('div', {
    staticClass: "user-profile clearfix"
  }, [_c('div', {
    staticClass: "admin-user-info"
  }, [_c('ul', {
    staticClass: "pointer"
  }, [_c('li', [_c('h4', {
    staticClass: "text-white"
  }, [_vm._v(_vm._s(_vm.currentTime) + " "), _c('small', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('這些都是我愛的名言，說不定會有一句話突然點醒你、或給你滿滿的力量，找回最初打拼的感覺 - Flowneat創辦人 Tim'),
      expression: "'這些都是我愛的名言，說不定會有一句話突然點醒你、或給你滿滿的力量，找回最初打拼的感覺 - Flowneat創辦人 Tim'"
    }],
    staticClass: "text-white"
  }, [_c('i', {
    staticClass: "fas fa-question"
  })])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "pointer",
    staticStyle: {
      "color": "#fff",
      "line-height": "2.2rem"
    },
    on: {
      "click": function($event) {
        _vm.changeSentence()
      }
    }
  }, [_vm._v(_vm._s(_vm.sentence_now.word) + "  "), _c('span', {
    staticStyle: {
      "background": "#fff",
      "color": "#222",
      "padding": "2px",
      "white-space": "nowrap"
    }
  }, [_vm._v(_vm._s(_vm.sentence_now.from))])])])])])])]), _vm._v(" "), _c('ul', {
    staticClass: "list-accordion tree-style text-left"
  }, [_c('li', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.GoDashbaord()
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('li', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.GoContact()
      }
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('li', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.GoOrganization()
      }
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('li', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.GoFinances()
      }
    }
  }, [_vm._m(3)]), _vm._v(" "), _c('li', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.GoProduct()
      }
    }
  }, [_vm._m(4)]), _vm._v(" "), (_vm.user.permission == 'admin') ? _c('li', {
    staticClass: "list-title"
  }, [_vm._v("管理員")]) : _vm._e(), _vm._v(" "), (_vm.user.permission == 'admin') ? _c('li', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.GoMembers()
      }
    }
  }, [_vm._m(5)]) : _vm._e(), _vm._v(" "), (_vm.user.permission == 'admin') ? _c('li', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.GoCompany()
      }
    }
  }, [_vm._m(6)]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "fa fa-file-invoice-dollar"
  }), _c('span', {
    staticClass: "list-label v-step-0-1"
  }, [_vm._v("交易管理")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _c('span', {
    staticClass: "list-label"
  }, [_vm._v("客戶管理")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "fa fa-building"
  }), _c('span', {
    staticClass: "list-label"
  }, [_vm._v("客戶公司")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "fas fa-dollar-sign"
  }), _c('span', {
    staticClass: "list-label"
  }, [_vm._v("帳務管理")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "fas fa-server"
  }), _c('span', {
    staticClass: "list-label"
  }, [_vm._v("服務項目")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "fa fa-users"
  }), _c('span', {
    staticClass: "list-label"
  }, [_vm._v("成員設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "fas fa-info"
  }), _c('span', {
    staticClass: "list-label"
  }, [_vm._v("公司基本資料")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e593bbd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/LeftSideBar.vue
// module id = 671
// module chunks = 4